import dynamic from "next/dynamic";

const VideoSlider = dynamic(() => import("./VideoSlider"), { ssr: false });

const VideoSliderWithProps = ({ blok }: { blok: any }) => {
  return <VideoSlider sectionTitle={blok.sectionTitle} videoItems={blok.videoItems} />;
};

export default VideoSliderWithProps;
